import { Fragment } from 'react';
import { WidgetType } from './widget.types';
import WeatherWidget, { WeatherWidgetConfig } from './WeatherWidget';
import AlertWidget, { AlertWidgetConfig } from './AlertWidget';
import MapWidget, { MapWidgetConfig } from './MapWidget';
import StatusWidget, { StatusWidgetConfig } from './StatusWidget';
import TaskWidget, { TaskWidgetConfig } from './TaskWidget';
import { InventoryWidget } from './InventoryWidget/InventoryWidget';
import { InventoryWidgetConfig } from './InventoryWidget/InventoryWidgetConfig';
import { DeviationWidget } from './common/DeviationWidget/DeviationWidget';
import { LoadDeviationWidgetConfig } from './LoadDeviationWidget/LoadDeviationWidgetConfig';
import { DeliverDeviationWidgetConfig } from './DeliverDeviationWidget/DeliverDeviationWidgetConfig';
export const widgetSizeEditModalName = '@@widget/size/edit';
export const widgetsMap = {
    [WidgetType.TASK]: TaskWidget,
    [WidgetType.ALARM]: AlertWidget,
    [WidgetType.WEATHER]: WeatherWidget,
    [WidgetType.STATUS]: StatusWidget,
    [WidgetType.MAP]: MapWidget,
    [WidgetType.INVENTORY]: InventoryWidget,
    [WidgetType.LOAD_DEVIATION]: DeviationWidget,
    [WidgetType.DELIVER_DEVIATION]: DeviationWidget,
    [WidgetType.DRIVE]: Fragment,
};
export const widgetsConfigMap = {
    [WidgetType.TASK]: TaskWidgetConfig,
    [WidgetType.ALARM]: AlertWidgetConfig,
    [WidgetType.WEATHER]: WeatherWidgetConfig,
    [WidgetType.STATUS]: StatusWidgetConfig,
    [WidgetType.MAP]: MapWidgetConfig,
    [WidgetType.INVENTORY]: InventoryWidgetConfig,
    [WidgetType.LOAD_DEVIATION]: LoadDeviationWidgetConfig,
    [WidgetType.DELIVER_DEVIATION]: DeliverDeviationWidgetConfig,
    [WidgetType.DRIVE]: null,
};
//# sourceMappingURL=WidgetConfig.js.map